<template>
  <div class="contact">
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
		</base-banner>

		<base-goto color="white" :breadcrumbs="breadcrumbs"></base-goto>

		<base-divider></base-divider>

		<div id="content" class="white">
			<div id="about" class="sec">
				<v-container :class="MIXIN_SETUP_UI.defaultSidePadding">
					<v-row>
						<v-col
							cols="12" sm="12" md="4" lg="4" xl="4"
							v-for="(description, key) in descriptions"
							:key="key"
							data-aos="fade-up"
						>
							<div class="text-center">
								<div :class="MIXIN_SETUP_UI.header" class="main-text-color font-weight-bold">{{ description.title }}</div>
								<p :class="MIXIN_SETUP_UI.subtitle">{{ description.caption }}</p>
								<!-- <h1>{{ description.title }}</h1>
								<p>{{ description.caption }}</p> -->
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
			<div id="steps" class="sec">
				<v-container :class="MIXIN_SETUP_UI.defaultSidePadding">
					<v-row justify="center">
						<div class="text-center mb-10 pb-10 primary--text">
							<div
								class="mb-3 font-weight-bold"
								data-aos="fade-up"
								:class="MIXIN_SETUP_UI.header"
							>
								We'll look after you.
							</div>
							<div
								data-aos="fade-up"
								:class="MIXIN_SETUP_UI.title"
							>
								You can make an appointment with a Medgate doctor at any time, day or night.
							</div>
						</div>
					</v-row>
					<v-row>
						<v-card
							:rounded="$vuetify.breakpoint.mdAndUp ? 'xl' : ''"
							flat
							data-aos="fade-up"
						>
							<v-row>
								<v-col cols="12" sm="12" md="6" lg="6" xl="6" class="ma-0 pa-0">
									<v-img contain src="@/assets/images/others/doc_cp2.png" height="700px"></v-img>
								</v-col>
								<v-col
									cols="12" sm="12" md="6" lg="6" xl="6"
									class="ma-0 py-0"
								>
									<v-row class="pl-0 ml-0 py-5 pr-5 step">
										<v-col cols="3">
											<base-step-number
												:number="1"
											></base-step-number>
										</v-col>
										<v-col cols="9" data-aos="fade-left">
												<div>
													<div :class="MIXIN_SETUP_UI.title" class="font-weight-bold">Schedule an appointment</div>
													<p :class="MIXIN_SETUP_UI.subtitle">
														Book an appointment for your medical consultation with the Medgate App over the phone, through SMS, or through this link: click here:
													</p>
													<!-- IOS -->
													<v-btn
														rounded
														:x-large="!MIXIN_SETUP_UI.isSmallButton"
														:small="MIXIN_SETUP_UI.isSmallButton"
														dark
														depressed
														color="#1665ce"
														class="my-2"
													>
														<v-icon left>mdi-apple</v-icon>
														Download IOS App
													</v-btn>

													<!-- Android -->
													<v-btn
														rounded
														:x-large="!MIXIN_SETUP_UI.isSmallButton"
														:small="MIXIN_SETUP_UI.isSmallButton"
														depressed
														color="white"
														class="blue--text text--darken-3 my-2"
													>
														<v-icon left>mdi-android</v-icon>
														Download Android App
													</v-btn>
												</div>
										</v-col>

										<v-col cols="3">
											<base-step-number :number="2"></base-step-number>
										</v-col>
										<v-col cols="9" data-aos="fade-left">
											<div>
												<div :class="MIXIN_SETUP_UI.title" class="font-weight-bold">Speak to a doctor</div>
												<p :class="MIXIN_SETUP_UI.subtitle">
													Have your medical consultation with a Medgate doctor on the agreed date and time.
												</p>
											</div>
										</v-col>

										<v-col cols="3">
											<base-step-number :number="3"></base-step-number>
										</v-col>
										<v-col cols="9" data-aos="fade-left">
											<div>
												<div :class="MIXIN_SETUP_UI.title" class="font-weight-bold">
													Receive your Certificate of Medical Teleconsultation
												</div>
												<p :class="MIXIN_SETUP_UI.subtitle">
													View your Certificate of Medical Teleconsultation to your email that will give you the recommended treatment by our specialist doctor.
												</p>
												<div class="text-right">
													<v-menu
														left
														offset-x
														open-on-hover
														transition="slide-x-transition"
													>
														<template v-slot:activator="{ on, attrs }">
															<span
																class="text-hover"
																v-bind="attrs"
																v-on="on"
															>
																<v-icon color="#40ecb8">mdi-chevron-right</v-icon>
																Call Doc now!
															</span>
														</template>

														<v-list class="px-5">
															<div
																v-for="(contact, index) in contacts"
																:key="index"
																class="py-1"
															>
																<p class="ma-0 pa-0 caption primary--text font-weight-black d-block">{{ contact.label }}</p>
																<p class="ma-0 pa-0">
																	<v-icon small color="black">mdi-phone-alert</v-icon>
																	{{ contact.number }}
																</p>
															</div>
														</v-list>
													</v-menu>
												</div>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card>
					</v-row>
				</v-container>
			</div>
		</div>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const VideoBannersApi = Repository.get("videoBanners");
const VideoDescriptionsApi = Repository.get("videoDescriptions");
const FootersApi = Repository.get("footers");

export default {
  name: "Contact",
  components: {
		//
  },
  data() {
    return {
			contacts: [],
			banner: [],
			descriptions: [],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
        {
					name: "Play Video",
					link: "/vide",
					active: true
				},
			]
		}
  },
  async mounted() {
		await this.getVideoBanner();
		this.setHeaderColor();
		this.getVideoDescriptions();
		this.getContacts();
  },
  methods: {
		setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getVideoBanner() {
			try {
				const { data } = await VideoBannersApi.get();
				
				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});
					
					let apiData = data.data[0];

					let buttons = apiData.buttons.map(button => {
						return {
							name: button.label,
							icon: button.image,
							link: button.redirect,
							color: JSON.parse(button.styling).color
						}
					});

					let banner = {
						buttons: buttons,
						image: apiData.background_image.main,
						caption: apiData.caption,
						title: apiData.title,
						titleColor: apiData.styles.titleColor,
						captionColor: apiData.styles.captionColor,
						backgroundColor: apiData.styles.backgroundColor
					}

					this.banner = banner;
				}

				console.log('[video-banner]', data, this.banner);
			}
			catch(error) {
				console.log(error);
			}
		},
		async getVideoDescriptions() {
			try {
				const { data } = await VideoDescriptionsApi.get();
				
				if (data) {
					data.data.sort(function(a, b) {
						return a.precedence - b.precedence;
					});

					let descriptions = data.data.map(description => {
						return {
							title: description.title,
							caption: description.caption,
						}
					});

					this.descriptions = descriptions;
				}

				console.log('[video-descriptions]', data, this.descriptions);
			}
			catch(error) {
				console.log(error);
			}
		},
		async getContacts() {
				try {
					const { data } = await FootersApi.get();
					
					if (data) {
						var values = [];

						data.data.map(contact => {
							values = contact.values.contacts.map(value => {
								return {
									label: value.label,
									number: value.numbers[0]
								}
							});
						});

						this.contacts = values;
					}

					console.log('[contacts]', data, this.contacts);
				}
				catch(error) {
					console.log(error);
				}
			}
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

// #header {
//   height: 700px;
// 	background: url("~@/assets/images/banners/playvid.jpg") no-repeat;
// 	background-size: cover;
// 	color: white;
// }

.main-text-color {
  color: $blue;
}

#about {
	h1 {
		color: $blue;
	}
}

#steps {
	background: $gray3;

	.step {
		background: $blue;
		height: 100%;
		border-top-right-radius: 24px;
		border-bottom-right-radius: 24px;
		color: white;
	}
}
</style>